import React, { createContext, useContext, useEffect, useState } from 'react';
import { isB2B } from '../../libs/env';

export const CustomOriginContext = createContext();

export const CustomOriginProvider = ({ children, userSource }) => {
  const [customOrigin, setCustomOrigin] = useState(window.location.origin);

  useEffect(() => {    
    if (userSource && isB2B.some(domain => userSource.includes(domain))) {
      setCustomOrigin(userSource);
    } else {
      setCustomOrigin(window.location.origin);
    }
  }, [userSource]);

  return (
    <CustomOriginContext.Provider value={customOrigin}>
      {children}
    </CustomOriginContext.Provider>
  );
};

export const useCustomOrigin = () => {
  return useContext(CustomOriginContext);
};
